//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { getEncrypted } from '~/pages/onlineService/utils';
import { chatMessages } from '~/net/fetch';
import axios from 'axios';
// 引入marked
const marked = require('marked');
marked.setOptions({
  // 禁用严格模式（允许不规范的标题语法）
  pedantic: false,
});
export default {
  name: 'ChatBox',
  data() {
    return {
      question: '',
      sendDisabled: false,
      conversationId: '',
      messageId: '',
      questionsAndAnswers: [],
      interval: null,
      timer: null,
      keyword: new Date().getTime(),
      cancel: null,
    };
  },
  props: {
    type: {
      type: [Number, null],
      default: null,
    },
    name: {
      type: String,
      required: true,
      default: '',
    },
  },
  beforeDestroy() {
    this.$bus.$off('clearAnswers', this.clearAnswers);
    this.clearAnswers();
  },
  computed: {
    ...mapState(['user']),
    showReferenceInfor() {
      return [0, 1, 2, 3].includes(this.type);
    },
    allFunctions() {
      const funs = [
        {
          title: this.type === null ? '一、为您匹配成果信息：' : '为您匹配成果信息：',
          key: 'goodsList',
        },
        {
          title: this.type === null ? '二、为您匹配需求信息：' : '为您匹配需求信息：',
          key: 'demandList',
        },
        {
          title: this.type === null ? '三、为您匹配服务机构信息：' : '为您匹配服务机构信息：',
          key: 'orgList',
        },
        {
          title: this.type === null ? '四、为您匹配技术经理人信息：' : '为您匹配技术经理人信息：',
          key: 'jlrList',
        },
      ];
      return this.type === null ? funs : [funs[this.type]];
    },
    appId() {
      const map = ['jstec-jsjlr-zcg', 'jstec-jsjlr-zxq', 'jstec-jsjlr-zfwjg', 'jstec-jsjlr-zjsjlr'];
      return this.type === null ? 'jstec-jsjlr' : map[this.type];
    },
  },
  mounted() {
    //清空会话
    this.$bus.$on('clearAnswers', this.clearAnswers);
  },
  methods: {
    showEmpty(structuredData, key) {
      return !structuredData[key] || (structuredData[key] && structuredData[key].length <= 0);
    },
    clearAnswers() {
      this.questionsAndAnswers = [];
      this.sendDisabled = false;
      //重置对话
      this.conversationId = '';
      //重置计时器
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      //取消请求
      if (this.cancel) {
        this.cancel('取消聊天请求');
        this.cancel = null;
      }
    },
    goDetail(item, active) {
      if (active === 'goodsList') {
        //打开新标签页
        item.id && window.open(`/goods?id=${item.id}`);
      } else if (active === 'demandList') {
        item.id && window.open(`/crowdsourcing/demandDetail?id=${item.id}&show=true`);
      } else if (active === 'orgList') {
        //打开新标签页
        item.id && window.open(`/shop?id=${item.id}`);
      }
    },

    fold(arrowDownRefs, thinkMessageRefs) {
      this.$nextTick(() => {
        const display = this.$refs[thinkMessageRefs][0].style.display;
        const arrowDown = this.$refs[arrowDownRefs][0].$el;
        this.$refs[thinkMessageRefs][0].style.display = display === 'none' ? 'block' : 'none';
        arrowDown.style.transform = display === 'none' ? 'rotate(0deg)' : 'rotate(180deg)';
      });
    },
    scrollToBottom() {
      this.$refs.ChatBox.scrollTop = this.$refs.ChatBox.scrollHeight;
    },
    getContenteditableValue() {
      const innerHTML = this.$refs.contenteditable.innerHTML;
      //获取innerHTL中的input标签
      const inputRegex = /<input[^>]*id="([^"]*)"[^>]*>/g;
      let match;
      let inputs;
      switch (this.type) {
        case 0:
          inputs = {
            goods: '技术领域',
            demand: '应用场景',
            plan: '技术要求',
          };
          break;
        case 1:
          inputs = {
            technology: '技术领域',
            planDesc: '解决方案描述',
          };
          break;
        case 2:
          inputs = {
            demand: '需求描述',
          };
          break;
        case 3:
          inputs = {
            demand: '需求描述',
          };
          break;
        default:
          inputs = {};
          break;
      }
      // 遍历所有匹配的input标签
      while ((match = inputRegex.exec(innerHTML)) !== null) {
        const inputId = match[1];
        const inputElement = document.getElementById(inputId);
        if (inputElement && inputElement.value) {
          inputs[inputId] = inputElement.value;
        }
      }
      // 替换原始字符串中的input标签为输入的值
      let processedContent = innerHTML;
      for (const id in inputs) {
        const value = inputs[id];
        const inputTagRegex = new RegExp(`<input[^>]*id="${id}"[^>]*>`, 'g');
        processedContent = processedContent.replace(inputTagRegex, value);
      }
      // console.log('提取的input值:', inputs);
      // console.log('处理后的内容:', processedContent);
      return processedContent;
    },
    typeWriterBuffer(content, index, key, callback) {
      function* generateText() {
        const tagRegex = /(<\/?[\w\s=\\"'-]+>)/g;
        const segments = content.split(tagRegex);
        let buffer = '';
        for (const segment of segments) {
          if (tagRegex.test(segment)) {
            buffer += segment;
            yield buffer;
            continue;
          }
          for (const char of segment) {
            buffer += char;
            yield buffer;
          }
        }
      }
      const gen = generateText();
      this.timer = setInterval(() => {
        const { value, done } = gen.next();
        if (done) {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
          callback();
        } else {
          // displayText = value;
          this.$set(this.questionsAndAnswers[index], key, value);
          // 每次添加字符后滚动到底部
          this.$nextTick(() => {
            this.scrollToBottom();
          });
        }
      }, 50);
    },
    typeWriter(content, index, key) {
      return new Promise((resolve) => {
        const fullAnswer = content;
        let displayText = '';
        let i = 0;
        this.interval = setInterval(() => {
          if (i < fullAnswer.length) {
            displayText += fullAnswer.charAt(i);
            this.$set(this.questionsAndAnswers[index], key, displayText);
            i++;
            // 每次添加字符后滚动到底部
            this.$nextTick(() => {
              this.scrollToBottom();
            });
          } else {
            if (this.interval) {
              clearInterval(this.interval);
              this.interval = null;
            }
            resolve('think 完成');
          }
        }, 50); // 调整速度，50毫秒一个字符
      });
    },
    //发送前校验
    sendBeforValidate() {
      if (!this.user) {
        this.$router.push('/login');
        return false;
      }
      //判断是否有输入
      else if (this.type === null && !this.question) {
        this.$Message.error('请输入您希望查找的资源:如新材料科技成果、专家、项目');
        return false;
      } else if (this.sendDisabled) {
        return false;
      } else {
        return true;
      }
    },
    //清空输入框或者初始化输入框
    clearInput() {
      let copyQuestion = '';
      if (!this.showReferenceInfor) {
        copyQuestion = this.question;
        this.question = '';
      } else {
        copyQuestion = this.getContenteditableValue();
        //如果是模板，提问后，重置输入框
        this.keyword = new Date().getTime();
      }
      return copyQuestion;
    },
    //重置对话
    resetConversation() {
      //取消请求
      if (this.cancel) {
        this.cancel('取消聊天请求');
        this.cancel = null;
      }
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      if (this.sendDisabled) {
        this.sendDisabled = false;
      }
    },
    //发送提问
    async generateAnswer(message) {
      //重置对话
      if (this.sendDisabled) {
        this.resetConversation();
      }
      //校验
      this.sendDisabled = true;
      //添加思考信息
      const question = message;
      const answer_question = {
        state: 'thinking',
        question,
        answer: '',
        thinkingTime: '0',
        think: '',
        structuredData: {
          goodsList: [],
          demandList: [],
          orgList: [],
          jlrList: [],
          show: false,
        },
      };
      this.questionsAndAnswers.push(answer_question);
      //提取questionsAndAnswers数组之后一项更新时间
      const lastIndex = this.questionsAndAnswers.length - 1;
      //数组最后一项
      const lastItemQ = this.questionsAndAnswers.at(-1);
      try {
        const body = {
          user: '0',
          query: this.name + question,
          conversation_id: '',
          appId: this.appId,
        };
        console.log('body', body);
        const encrypted = getEncrypted(body);
        this.$nextTick(() => {
          this.scrollToBottom();
        });
        //发送对话请求
        const [response, cancel] = chatMessages({
          data: encrypted,
        });
        this.cancel = cancel;
        const { code, data, duration } = await response;
        //更新时间
        this.$set(lastItemQ, 'thinkingTime', (duration / 1000).toFixed(2));
        //更新状态
        this.$set(lastItemQ, 'state', 'finished');
        if (code === '0000' && data) {
          const result = data;
          //结构化数据初始化
          const initDataJson = {
            goodsList: [],
            demandList: [],
            orgList: [],
            jlrList: [],
          };
          const jsonData = result?.jsonData ?? initDataJson;
          //markdown转html
          const markdownToHtml = marked.parse(result?.answer ?? '');
          console.log('markdownToHtml', markdownToHtml);
          //渲染html
          const renderHtml = () => {
            this.typeWriterBuffer(markdownToHtml, lastIndex, 'answer', () => {
              //结构化数据
              this.$set(lastItemQ, 'structuredData', {
                ...jsonData,
                show: true,
              });
              this.$nextTick(() => {
                //当所有的文字都渲染完成后，才可以发送下一条信息
                this.sendDisabled = false;
                this.scrollToBottom();
              });
            });
          };
          // 熏染思考过程
          this.typeWriter(result?.think ?? '', lastIndex, 'think').then(() => {
            //渲染回答和结构化数据
            renderHtml();
          });
        }
      } catch (error) {
        console.log(error);
        this.sendDisabled = false;
        if (axios.isCancel(error)) {
          //更新时间
          this.$set(lastItemQ, 'thinkingTime', 0);
          //更新状态
          this.$set(lastItemQ, 'state', 'finished');
          //更新状态
          this.$set(lastItemQ, 'think', '请求被取消');
        } else {
          //更新状态
          this.$set(lastItemQ, 'state', 'finished');
          this.$set(lastItemQ, 'think', '网络请求失败，请稍后重试');
        }
      }
    },
  },
};
